import { z } from "zod"

import { EKreaImageGenerationModelType } from "../../../../image/enums"
import { KREA_3_MAX_REFERENCES } from "../../../reference/contract"
import { baseImageGenerationSchema } from "../helpers"

// Explicit output sizes avoid the edit endpoint's unspecified automatic sizing bill.
export const KREA_IMAGE_SIZES = ["1024*1024", "1536*1024", "1024*1536", "2048*2048", "1680*2512"] as const

const kreaFields = {
  prompt: z.string().min(1).max(5000),
  variant: z.enum(["berry", "jam"]).default("berry"),
  resolution: z.enum(KREA_IMAGE_SIZES).default("1024*1024"),
  reasoning_level: z.enum(["low", "medium"]).default("low"),
  negative_prompt: z.string().max(1024).optional(),
  output_format: z.enum(["png", "jpeg"]).default("png"),
  seed: z.number().int().optional(),
}

export const krea3ObjectSchema = baseImageGenerationSchema.extend({
  modelId: z.literal(EKreaImageGenerationModelType.KREA_3),
  ...kreaFields,
})

export const krea3EditObjectSchema = baseImageGenerationSchema.extend({
  modelId: z.literal(EKreaImageGenerationModelType.KREA_3_EDIT),
  ...kreaFields,
  image_input: z.array(z.string().min(1)).min(1).max(KREA_3_MAX_REFERENCES),
})

export const validateKreaImageParameters = (
  params: { modelId?: unknown; variant?: unknown; negative_prompt?: unknown },
  context: z.RefinementCtx,
): void => {
  if (
    params.modelId !== EKreaImageGenerationModelType.KREA_3 &&
    params.modelId !== EKreaImageGenerationModelType.KREA_3_EDIT
  )
    return
  if (params.variant === "jam" && typeof params.negative_prompt === "string" && params.negative_prompt.length > 0) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["negative_prompt"],
      message: "Negative prompts are supported by Berry only; leave this empty for Jam",
    })
  }
}

export const krea3Schema = krea3ObjectSchema.superRefine(validateKreaImageParameters)
export const krea3EditSchema = krea3EditObjectSchema.superRefine(validateKreaImageParameters)
export type Krea3Params = z.infer<typeof krea3Schema>
export type Krea3EditParams = z.infer<typeof krea3EditSchema>
